import type { IconSvgObject } from './types';

const EqualIcon: IconSvgObject = [
  ["path", { d: "M5 15H19M5 9H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default EqualIcon;
